import { useGetActionsQuery } from "./actionsApiSlice"
import Action from "./Action"
//import useAuth from "../../hooks/useAuth"
import PulseLoader from 'react-spinners/PulseLoader'
import { useParams } from 'react-router-dom'
import { useNavigate } from "react-router-dom"

import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ActionsList = () => {
    //useTitle('geshtop-Exercise: Actions List')
    const { taskId, groupId, type } = useParams()
    const navigate = useNavigate();
    //const { username, isTeacher, isAdmin } = useAuth()
    const {
        data: actions,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetActionsQuery('actionsList', {
        refetchOnMountOrArgChange: true,
    })



    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess) {
        const { ids, entities } = actions
        const filteredIds =  ids.filter(actionId => entities[actionId].task === taskId)


        const tableContent = ids?.length && filteredIds.map(actionId => <Action key={`s${actionId}`} actionId={actionId} />)

        content = (
            <> <button
            className="icon-button"
            title="Back to tasks"
            onClick={()=>{ navigate(`/${type}/${groupId}/tasks/`)}}
        >
            <FontAwesomeIcon icon={faArrowAltCircleRight} />
        </button>
           
            <table className="table table--actions">
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th action__text">כותרת</th>
                        <th scope="col" className="table__th action__text">תוכן</th>
                        <th scope="col" className="table__th action__type">סוג</th>
                        <th scope="col" className="table__th action__status">מצב ההגשה</th>
                        <th scope="col" className="table__th action__edit">#</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
            </>
        )
    }

    return content
}
export default ActionsList